import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';

const RescheduleDialog = ({ open, meeting, onClose, onConfirm }) => {
  const { t } = useTranslation();
  const [newStart, setNewStart] = useState(null);
  const [newEnd, setNewEnd] = useState(null);

  // Reset picker state when meeting prop changes
  useEffect(() => {
    if (meeting) {
      setNewStart(dayjs(meeting.start));
      setNewEnd(dayjs(meeting.end));
    }
  }, [meeting]);

  const handleSave = () => {
    if (newStart && newEnd) {
      onConfirm({
        start: newStart.toISOString(),
        end: newEnd.toISOString(),
      });
    }
  };

  const isSaveDisabled = !newStart || !newEnd;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('reschedule_meeting')}</DialogTitle>
      <DialogContent>
        <Stack spacing={2} sx={{ mt: 2 }}>
          <div>
            <Typography variant="subtitle2" sx={{ mb: 1 }}>
              {t('current_date')}
            </Typography>
            <Typography variant="body2">{meeting?.date}</Typography>
          </div>

          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack spacing={2}>
              <DateTimePicker
                label={t('new_start_date')}
                value={newStart}
                onChange={setNewStart}
                slotProps={{
                  textField: {
                    fullWidth: true,
                  },
                }}
              />

              <DateTimePicker
                label={t('new_end_date')}
                value={newEnd}
                onChange={setNewEnd}
                slotProps={{
                  textField: {
                    fullWidth: true,
                  },
                }}
              />
            </Stack>
          </LocalizationProvider>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('cancel')}</Button>
        <Button onClick={handleSave} variant="contained" disabled={isSaveDisabled}>
          {t('save')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default RescheduleDialog;
